var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 1200,
        scrollable: "",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onVisibleChange },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("p", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("批量编辑产品说明信息")]),
      ]),
      _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
      _c(
        "Tabs",
        {
          attrs: { animated: false, "capture-focus": true },
          model: {
            value: _vm.editType,
            callback: function ($$v) {
              _vm.editType = $$v
            },
            expression: "editType",
          },
        },
        [
          _c(
            "TabPane",
            { attrs: { label: "产品列表", name: "productInfo" } },
            [
              _c("productPopupEditTabBathProductList", {
                ref: "productPopupEdit",
                on: { "chang-template-product": _vm.setProductUuid },
              }),
            ],
            1
          ),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfopOtherSpec"),
                    name: "productDesInfopOtherSpec",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfopOtherSpec"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfopOtherSpec,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfopOtherSpec",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfopOtherSpec",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInffeatures"),
                    name: "productDesInffeatures",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInffeatures"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInffeatures,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInffeatures",
                                  $$v
                                )
                              },
                              expression: "productForm.productDesInffeatures",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Row", { attrs: { justify: "center" } }),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfoCultivation"),
                    name: "productDesInfoCultivation",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoCultivation"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoCultivation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoCultivation",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoCultivation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfoCommonProblem"),
                    name: "productDesInfoCommonProblem",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoCommonProblem"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm.productDesInfoCommonProblem,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoCommonProblem",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoCommonProblem",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfoafterService"),
                    name: "productDesInfoafterService",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoafterService"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoafterService,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoafterService",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoafterService",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfodiscountPolicy"),
                    name: "productDesInfodiscountPolicy",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfodiscountPolicy"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm.productDesInfodiscountPolicy,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfodiscountPolicy",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfodiscountPolicy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype("productDesInfoPdfLinkList"),
                    name: "productDesInfoPdfLinkList",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("pdf-upload", {
                            attrs: {
                              productUuid: _vm.productUuid,
                              uploadData: _vm.getUploadData(
                                "productDesInfoPdfLinkList"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value: _vm.productForm.productDesInfoPdfLinkList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoPdfLinkList",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoPdfLinkList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype(
                      "productDesInfoDiseasePestControl"
                    ),
                    name: "productDesInfoDiseasePestControl",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoDiseasePestControl"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm
                                  .productDesInfoDiseasePestControl,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoDiseasePestControl",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoDiseasePestControl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.hasTemplateProduct
            ? _c(
                "TabPane",
                {
                  attrs: {
                    label: _vm.getNameByTabtype(
                      "productDesInfoPostHarvestProcessing"
                    ),
                    name: "productDesInfoPostHarvestProcessing",
                  },
                },
                [
                  _c(
                    "Row",
                    { staticClass: "quillRow", attrs: { justify: "center" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "20", offset: "2" } },
                        [
                          _c("quill-upload", {
                            attrs: {
                              uploadImgUrl: _vm.uploadImgUrlWithPath,
                              uploadData: _vm.getUploadData(
                                "productDesInfoPostHarvestProcessing"
                              ),
                              qillHeight: _vm.qillHeight,
                            },
                            model: {
                              value:
                                _vm.productForm
                                  .productDesInfoPostHarvestProcessing,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productDesInfoPostHarvestProcessing",
                                  $$v
                                )
                              },
                              expression:
                                "productForm.productDesInfoPostHarvestProcessing",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          this.$checkAccessArray(["B", "C"]) && _vm.editType != "productInfo"
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click:
                      _vm.saveListProductDescriptiveInformationSingleAttribute,
                  },
                },
                [_vm._v(_vm._s("保存" + _vm.getNameByTabtype(_vm.editType)))]
              )
            : _vm._e(),
          this.$checkAccessArray(["B", "C"])
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveListProductDescriptiveInformation },
                },
                [_vm._v("保存说明信息")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }